import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { Fonts, Metrics } from 'APP/Themes'

export const MarkdownStyles = {
  p: {
    marginBottom: Metrics.baseMargin * 1.25,
    ...Fonts.style.body,
  },
}

export const ContentStyles = {
  paddingTop: Metrics.baseMargin,
  paddingHorizontal: Metrics.baseMargin * 2,
  paddingBottom: Metrics.baseMargin + Metrics.bottomSpace,
}

export const ModalContainer = styled.View`
  flex: 1;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-top: ${({ theme }) => theme.metrics.statusBarHeight + theme.metrics.baseMargin}px;
  background-color: ${({ theme }) => theme.colors.background};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  ${({ theme }) => theme.shadows.normal}
`

export const HeaderContainer = styled.View`
  display: flex;
  flex-direction: row;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.6}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const TitleH1 = styled(Typography)`
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

export const TitleH2 = styled(Typography)`
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
`
